import React from 'react'

const Unauth = () => {
  return (
    <div className=' w-full h-screen text-center'><h1>Unauth</h1></div>
  )
}

export default Unauth;